import { render, staticRenderFns } from "./ModelImageView.vue?vue&type=template&id=045b41b8&scoped=true"
import script from "./ModelImageView.vue?vue&type=script&lang=js"
export * from "./ModelImageView.vue?vue&type=script&lang=js"
import style0 from "./ModelImageView.vue?vue&type=style&index=0&id=045b41b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b41b8",
  null
  
)

export default component.exports